import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { useAuth } from "@/lib/auth-context";
import { useSegments } from "@/features/settings/use-segments";
import { SegmentsTabs } from "./_components/segments-tabs";

// Phase 7 sub-bucket 18 — SPA port of /app/admin/settings/segments/page.tsx.

export function SegmentsListPage() {
  const session = useAuth().session;
  const canManage = !!session?.permissions.includes("settings.write");
  const query = useSegments();

  return (
    <div>
      <Link
        to="/admin/settings"
        className="mb-4 inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-3 w-3" />
        Back to settings
      </Link>

      <header className="mb-7">
        <h1 className="font-display text-3xl font-semibold tracking-tight">
          Segments
        </h1>
        <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
          Saved boolean filters for partners and deals. Use them inside Saved
          Views and audience scoping.
        </p>
      </header>

      {query.isLoading ? (
        <div className="space-y-2">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-16 w-full rounded-xl" />
          ))}
        </div>
      ) : (
        <SegmentsTabs segments={query.data ?? []} canManage={canManage} />
      )}
    </div>
  );
}
